import { UPDATE_ORDER_STATUS_WIDGET } from "./actionTypes"

export const updateOrderStatusWidget = data => {
  return {
    type: UPDATE_ORDER_STATUS_WIDGET,
    payload: data,
  }
}
